import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less';
import animated from 'animate.css'

Vue.config.productionTip = false

Vue.use(Antd)
// Vue.use(animated)

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
